import React from "react";
import "./ParentSubScoreItem.scss";
import ParentScoreItemStatusBlock from "./ParentScoreItemStatusBlock";
import ParentPeopleLevels from "./ParentPeopleLevels";
import { isNotNullOrUndefined } from "../../../../../services/util";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getPercentileInfo, isUsingFourCategories } from "../../../util/cutscores";

const ParentSubScoreItem = ({ i18n, name, values }) => {
  const { t } = useTranslation(['teacher_parent_report'], {i18n})
  const selectedStatePercentileCuts = useSelector(state => state.reports.teacher.selectedStatePercentileCuts);
  const isUsingFourCutlines = isUsingFourCategories(selectedStatePercentileCuts);

  if(!values) return null;
  if(!isNotNullOrUndefined(values.percentile)) return null; // do not render if no data
  
  const { percentile, color, pacing, label } = values;

  let percentileInfo = null;
  if (isUsingFourCutlines) percentileInfo = getPercentileInfo(percentile, selectedStatePercentileCuts);

  return (
    <div className="parent-columned-layout parent-subscore-item">
      <div className="__value parent-subscore-item-name"><h3>{name}</h3></div>
      <div className="__value parent-subscore-item-percentile">
        <ParentPeopleLevels pacing={pacing} percentage={percentile} i18n={i18n} percentileInfo={percentileInfo} />
      </div>
      <div className="__value parent-subscore-item-status">
        <ParentScoreItemStatusBlock color={color} pacing={pacing} i18n={i18n} percentileInfo={percentileInfo} />
      </div>
      <div className="__value parent-subscore-item-description">{t(`domain_descriptions.${label}`)}</div>
    </div>
  )
}

export default ParentSubScoreItem